import type { ICianMFUIElement } from '@cian/mf-registry/browser';
import { useEffect, useRef, useState } from 'react';

interface IUseAdBannerMicrofrontendResult {
  microfrontendRef: React.MutableRefObject<ICianMFUIElement | null>;
  isReady: boolean;
}

/**
 * Монтирует микрофронтенд только на клиенте: `isReady` переключается в `true` через
 * `setTimeout(..., 0)` после маунта, чтобы реклама не рендерилась на SSR.
 */
export function useAdBannerMicrofrontend(): IUseAdBannerMicrofrontendResult {
  const microfrontendRef = useRef<ICianMFUIElement | null>(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsReady(true), 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return { microfrontendRef, isReady };
}
